import { readUnhandledEnumCase } from 'rpc-client-utils';
const SUB_PERSONA_TO_PERSONA = {
  MARKETING_MANAGER: 'MARKETING',
  MARKETING_REP: 'MARKETING',
  SALES_MANAGER: 'SALES',
  SALES_REP: 'SALES',
  SERVICE_MANAGER: 'SERVICE',
  SERVICE_REP: 'SERVICE',
  CUSTOMER_SUCCESS_MANAGER: 'SERVICE'
};
export const mapSubPersonaToPersona = subPersona => {
  return SUB_PERSONA_TO_PERSONA[readUnhandledEnumCase(subPersona)] || 'DEFAULT';
};